import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { isArray } from 'rxjs/internal-compatibility';

import { FormControlComponent } from '../../../../abstracts/form-control.abstract';

@Component({
    selector: 'app-generic-checkbox',
    templateUrl: './generic-checkbox.component.html',
    styleUrls: ['./generic-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: GenericCheckboxComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: GenericCheckboxComponent,
        },
    ],
})
/**
 * Generic checkbox - inspired by: https://mihalcan.medium.com/angular-multiple-check-boxes-45ad2119e115
 *
 * @param data: any[] - Data array to generate your checkbox component.
 *
 * @param labelRef: string | string[] - The object property which should be used as label.
 * You can pass a single string value or several props in an array - eg: (['firstname', 'lastname']).
 *
 * @param valueRef: string - The object property you want to get as form value (eg: 'id').
 *
 * @param multipleSelection: boolean - Indicates whether you want to allow multiple checkbox selection (default: true).
 *
 * @return valueRef of checked checkbox(es) as reactive form control data.
 * */
export class GenericCheckboxComponent extends FormControlComponent {
    @Input() public data: any[];
    @Input() public labelRef: string | string[];
    @Input() public valueRef: string;
    @Input() public multipleSelection = true;

    public form: FormGroup = new FormGroup({
        items: new FormControl(null),
    });

    constructor() {
        super();
    }

    public getLabel(item: any): string {
        if (!isArray(this.labelRef)) {
            return item[this.labelRef];
        }
        let fullLabel: string = '';
        this.labelRef.forEach((label: string, index: number) => {
            fullLabel += item[label] + (index === this.labelRef.length ? '' : ' ');
        });
        return fullLabel;
    }

    public writeValue(obj: any): void {
        this.value = obj;
        this.items.patchValue(obj);
    }

    public onValueChange(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.items.value;
        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public validate(): ValidationErrors | null {
        return this.items.invalid ? this.items.errors : null;
    }

    public get items(): FormControl {
        return this.form.get('items') as FormControl;
    }
}
